import SearchParamsBase from '../../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import OfficeHelper from '../../../../Helpers/ModelHelpers/OfficeHelper';
import UserService from '../../../../Services/userService';

export default class ClientPrePaymentsSearchParams extends SearchParamsBase {
  initialize() {
    const userOffice = UserService.GetOfficeIdOfLoggedInUser();
    this.OfficeIds = OfficeHelper.GetDefaultOfficeIds(userOffice);
    this.ClientNameOrId = '';
    this.PaymentTypes = [];
    this.PaymentRef = '';
    this.AmountPaidMoreThan = '';
    this.AmountPaidLessThan = '';
    this.InvoiceNumber = '';
    this.ClientInvoiceNumber = '';
    this.HasOutstanding = '';
  }

  static fieldsInSearchBox = [
    { fieldName: 'ClientNameOrId', label: 'Client Name or ID', className: 'col-4', type: InputTypesEnum.Text },
    {
      fieldName: 'PaymentTypes',
      label: 'Payment Method',
      className: 'col-4',
      type: InputTypesEnum.MultiChoice,
      options: ClientPrePaymentsSearchParams.getTypeOptions(),
    },
    { fieldName: 'ClientInvoiceNumber', label: 'Bare Invoice No.', className: 'col-4', type: InputTypesEnum.Number },
    { fieldName: 'InvoiceNumber', label: 'Client Invoice No.', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'PaymentRef', label: 'Internal Ref.', className: 'col-4', type: InputTypesEnum.Text },
    {
      fieldName: 'HasOutstanding',
      label: 'Has Outstanding',
      className: 'col-4',
      type: InputTypesEnum.EmptyYesNoSelect,
    },
    {
      fieldName: 'AmountPaidLessThan',
      label: 'Amount Paid Less Than',
      className: 'col-4',
      type: InputTypesEnum.NumberWithTwoDecimalPlaces,
    },
    {
      fieldName: 'AmountPaidMoreThan',
      label: 'Amount Paid More Than',
      className: 'col-4',
      type: InputTypesEnum.NumberWithTwoDecimalPlaces,
    },
    {
      fieldName: 'OfficeIds',
      label: 'Office',
      className: 'col-4',
      type: InputTypesEnum.OfficeOrGroupMultiSelect,
    },
  ];

  static getTypeOptions() {
    return [
      { label: 'Prepay', value: 1 },
      { label: 'Fee Prepay', value: 30 },
      { label: 'Reimbursement Prepay', value: 31 },
    ];
  }

  static iconName = 'fa-solid fa-search';
  static saveType = 'ClientPrePaymentsSearchParams';
}
